import { todayDate } from "../../common/DateFormatters";

const UpcomingDonations = ({ barCode, translationMap }) => {
  return (
    <>
        <div className="donation_summary_box">
        <h6 className="MainTitleOne">
              {translationMap?.donationSummary}
            </h6>
            <p className="small_title">{translationMap?.upcomingDonations}</p>
            {barCode &&
        <div className="blood_donation_summary_box blood_donation_summary_cloumn_box">
                <div className="bd_summary_box bd_summary_box3">
                  <div className="bd_summary_text_box">
                    <p className="date_text" style={{ direction: "ltr" }}>
                      {todayDate()}
                    </p>
                    <p className="Gray_Title bottom_text bottom_text_italic">
                      {translationMap?.codeValidToday}
                    </p>
                  </div>
                  <div className="bd_summary_icon_box">
                    <img
                src={`data:image/png;base64,${barCode}`}
                alt="Displaying barcode" />
              
                  </div>
                </div>
              </div>
        }
          </div>
        </>);

};

export default UpcomingDonations;